import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <section
      className="relative bg-[#ffffff] p-6 rounded-2xl flex items-center justify-center space-y-6 
      w-full md:px-20 px-4"
    >
      <div className="flex flex-col gap-6 items-start">
        <div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#753ABF] leading-snug w-full md:w-3/5 lg:w-3/5">
            Your Safety, Dignity & Independence — In One Card
          </h2>
        </div>

        <div className="relative inline-block">
          <span className="absolute -bottom-2 -right-2 w-full h-full bg-purple-600 rounded-lg"></span>
          <button
            className="bg-black text-white text-lg font-bold px-6 py-2 rounded relative z-10"
            onClick={() => navigate("/auth")}
          >
            Get Started
          </button>
        </div>
      </div>

      <img
        src="/Assets/Images/hero.svg"
        alt="Smiling woman holding the Project Sunflower Lanyard medical emergency card; and a smiling man wearing a backpack holding the card."
        className="hidden md:block w-[1000px] h-[400px] object-contain"
      />
    </section>
  );
};
export default HeroSection;